<!-- eslint-disable vue/html-self-closing -->
<template>
  <section class="" v-if="pipelines">
    <div class="container">
      <gf-custom-alert
        v-if="
          hasPipelineConfiguration !== null &&
          !hasPipelineConfiguration &&
          (getActionAvailabilityFlag(ACTION_ENUM.EXECUTE_CI_CD) ||
            getActionAvailabilityFlag(ACTION_ENUM.MANAGE_CI_CD_SETTINGS) ||
            getActionAvailabilityFlag(ACTION_ENUM.PUSH))
        "
        variant="info"
        class="mb-3"
      >
        <template #body>
          {{ $t('ci_cd.pipeline.configurationNotFound') }}
          <span
            v-if="
              getActionAvailabilityFlag(ACTION_ENUM.MANAGE_CI_CD_SETTINGS) ||
              getActionAvailabilityFlag(ACTION_ENUM.PUSH)
            "
          >
            <br />
            <a
              v-if="getActionAvailabilityFlag(ACTION_ENUM.MANAGE_CI_CD_SETTINGS)"
              :href="`/project/${$route.params.alias}/${$route.params.projectAlias}/setting/cicd`"
            >
              {{ $tc('ci_cd.pipeline.configurationNotFoundSolution', 0) }}
            </a>
            <span v-else>{{ $tc('ci_cd.pipeline.configurationNotFoundSolution', 0) }}</span>
            {{ $tc('ci_cd.pipeline.configurationNotFoundSolution', 1) }}
            <router-link
              v-if="getActionAvailabilityFlag(ACTION_ENUM.PUSH)"
              tag="a"
              :to="{ name: 'pipeline-templates' }"
            >
              {{ $tc('ci_cd.pipeline.configurationNotFoundSolution', 2) }}.
            </router-link>
            <span v-else>{{ $tc('ci_cd.pipeline.configurationNotFoundSolution', 2) }}.</span>
          </span>
        </template>
      </gf-custom-alert>
      <navigation-tabs
          class="py-2"
          :links="tabs"
          :is-reactive="true"
      />
      <div class="сi-cd-pipelines">
        <div class="mb-3 сi-cd-pipelines__actions pt-3">
          <div class="сi-cd-pipelines__actions-filters">
              <project-branch-selector
                id="branch-select"
                v-if="alias && projectAlias"
                v-model="selectedBranch"
                class="ci-cd-pipelines__filter"
                :searchable="true"
                :alias="alias"
                :project-model="projectAlias"
                :show-all-option="true"
                :clearable="true"
                :placeholder="$t('message.select_branch')"
                @input="onSelectorInput('branch')"
              />
            <project-tag-selector
              v-if="alias && projectAlias"
              v-model="selectedTag"
              class="ci-cd-pipelines__filter"
              :user-alias="alias"
              :project-alias="projectAlias"
              :clearable="true"
              :placeholder="$t('message.select_tag')"
              @input="onSelectorInput('tag')"
            />
          </div>
          <div class="сi-cd-pipelines__actions-buttons">
            <router-link
              v-if="
                applicationVersion !== 'cloudweb' &&
                getActionAvailabilityFlag(ACTION_ENUM.MANAGE_PIPELINE_SCHEDULE)
              "
              class="btn-shedule btn btn-primary btn-sm"
              :to="{ name: 'pipelines-schedule' }"
              tag="button"
            >
              <span>{{ $t('ci_cd.scheduler.schedulerTitle') }}</span>
            </router-link>
            <a
              v-if="getActionAvailabilityFlag(ACTION_ENUM.EXECUTE_CI_CD)"
              class="btn-execute btn btn-primary btn-sm"
              :class="{ disabled: pipelineIsCreating }"
              :href="`/project/${$route.params.alias}/${$route.params.projectAlias}/ci-cd/pipeline/create`"
            >
              <span :class="{ 'd-none': cacheIsClearing }">
                {{ $t('ci_cd.pipeline.create') }}
              </span>
              <div
                class="gf-loading-ring --secondary"
                :class="{ 'd-none': !cacheIsClearing }"
              ></div>
            </a>

            <button
              v-if="getActionAvailabilityFlag(ACTION_ENUM.RESET_RUNNER_CACHE)"
              type="button"
              class="btn-cache btn btn-outline-secondary btn-sm"
              :class="{ disabled: pipelineIsCreating }"
              @click.prevent="openClearCachePipelinesModalWindow"
            >
              <span :class="{ 'd-none': cacheIsClearing }">
                {{ $t('ci_cd.pipeline.clearRunnerCaches') }}
              </span>
              <div
                class="gf-loading-ring --secondary"
                :class="{ 'd-none': !cacheIsClearing }"
              ></div>
            </button>

            <!-- <div
              class="icon-setting"
              v-if="getActionAvailabilityFlag(ACTION_ENUM.EXECUTE_CI_CD)"
            >
              <i
                class="gf-icon gf-icon-gear text-secondary f2 cursor-pointer mt-1"
                data-target="pipelineSettingsModal"
              ></i>
            </div> -->
          </div>
        </div>

        <ci-cd-pipelines-table
          :pipelines="pipelines"
          @restart="openRestartPipelineModalWindow"
          @cancel="openCancelPipelineModalWindow"
          @delete="openDeletePipelineModalWindow"
        />

        <pagination
          v-if="pipelines.page && pipelines.page.totalPages > 1"
          :pager="pipelines.page"
          @change="paginatePipeline"
        />

        <gf-custom-modal-window
          ref="gfCustomModalWindowPipelinesClearCache"
          gf-modal-data-name="pipelinesSettingsModalPipelineClearCache"
          :gf-modal-header="$t('ci_cd.pipeline.clearRunnerCachesConfirmation')"
          gf-modal-wrapper-width="600px"
        >
          <template #body>
            <div class="mb-3">
              {{ $t('ci_cd.pipeline.clearRunnerCachesDescription') }}
            </div>
            <div class="d-flex justify-content-end">
              <button
                type="button"
                class="btn btn-secondary btn-sm m-1"
                @click="closeClearCachePipelinesModalWindow"
              >
                {{ $t('message.cancel') }}
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm m-1"
                @click="clearPipelinesCache"
              >
                {{ $t('ci_cd.pipeline.clearRunnerCaches') }}
              </button>
            </div>
          </template>
        </gf-custom-modal-window>

        <gf-custom-modal-window
          ref="gfCustomModalWindowPipelineSettings"
          gf-modal-data-name="pipelineSettingsModal"
          :gf-modal-header="$t('ci_cd.pipeline.configuration')"
          gf-modal-wrapper-width="600px"
        >
          <template #body>
            <div class="form-group">
              <label>{{ $tc('message.branch', 0) }}</label>
              <project-branch-selector
                v-model="form.branch"
                :searchable="true"
                :alias="alias"
                :project-model="projectAlias"
                placeholder="Выберите ветку"
              />
            </div>

            <div class="d-flex justify-content-end">
              <button
                type="button"
                class="btn btn-secondary btn-sm m-1"
                @click="closePipelineSettingsModal"
              >
                {{ $t('message.cancel') }}
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm m-1"
                @click="runPipelineWithSettings"
              >
                {{ $t('ci_cd.pipeline.create') }}
              </button>
            </div>
          </template>
        </gf-custom-modal-window>

        <gf-custom-modal-window
          ref="gfCustomModalWindowPipelineRestart"
          gf-modal-data-name="pipelineSettingsModalPipelineRestart"
          :gf-modal-header="$t('ci_cd.pipeline.restartConfirmation')"
          gf-modal-wrapper-width="600px"
        >
          <template #body>
            <div class="d-flex justify-content-end">
              <button
                type="button"
                class="btn btn-secondary btn-sm m-1"
                @click="closeRestartPipelineModalWindow"
              >
                {{ $t('message.cancel') }}
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm m-1"
                @click="restartPipelineItem"
              >
                {{ $t('ci_cd.pipeline.restart') }}
              </button>
            </div>
          </template>
        </gf-custom-modal-window>

        <gf-custom-modal-window
          ref="gfCustomModalWindowPipelineCancel"
          gf-modal-data-name="pipelineSettingsModalPipelineCancel"
          :gf-modal-header="$t('ci_cd.pipeline.cancelConfirmation')"
          gf-modal-wrapper-width="600px"
        >
          <template #body>
            <div class="d-flex justify-content-end">
              <button
                type="button"
                class="btn btn-secondary btn-sm m-1"
                @click="closeCancelPipelineModalWindow"
              >
                {{ $t('message.cancel') }}
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm m-1"
                @click="cancelPipelineItem"
              >
                {{ $t('ci_cd.pipeline.cancelPipeline') }}
              </button>
            </div>
          </template>
        </gf-custom-modal-window>

        <gf-custom-modal-window
          ref="gfCustomModalWindowPipelineDelete"
          gf-modal-data-name="pipelineSettingsModalPipelineDelete"
          :gf-modal-header="$t('ci_cd.pipeline.deleteConfirmation')"
          gf-modal-wrapper-width="600px"
        >
          <template #body>
            <div class="d-flex justify-content-end">
              <button
                type="button"
                class="btn btn-secondary btn-sm m-1"
                @click="closeDeletePipelineModalWindow"
              >
                {{ $t('message.cancel') }}
              </button>
              <button
                type="button"
                class="btn btn-danger btn-sm m-1"
                @click="deletePipelineItem"
              >
                {{ $t('message.delete') }}
              </button>
            </div>
          </template>
        </gf-custom-modal-window>
      </div>
    </div>
  </section>
  <pacman-loader v-else />
</template>

<script>
import { smallNotification } from '@shared/services/gf.notification.service';

import CiCdPipelinesTable from '@shared/modules/ci-cd/components/ci-cd-pipelines-table';
import Pagination from '@shared/shared-components/shared/pagination';
import PacmanLoader from '@shared/shared-components/shared/packman-loader';
import gfCustomModalWindow from '@shared/shared-components/shared/GfCustomModalWindow';
import CiCdMessages from '@shared/modules/ci-cd/ci-cd.messages';
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';
import CiCdService from '../ci-cd.service';
import CiCdTabs from '../components/ci-cd-tabs.vue';
import GfCustomAlert from '@/shared-modules/shared-components/shared/GfCustomAlert';
import NavigationTabs from '@shared/shared-components/shared/navigation-tabs';

export default {
  components: {
    PacmanLoader,
    Pagination,
    CiCdPipelinesTable,
    gfCustomModalWindow,
    CiCdTabs,
    GfCustomAlert,
    NavigationTabs
  },
  data() {
    return {
      showPipelineSettings: false,
      form: {},
      selectedBranch: null,
      selectedTag: null,
      alias: null,
      projectAlias: null,
      pipeline: null,
      cacheIsClearing: false,
      tabs: [
        {
          title: 'Конвейеры',
          to: {
            name: 'pipelines'
          }
        },
        {
          title: 'Задачи',
          to: {
           name: 'ci-jobs'
          }
        },
      ]
    };
  },
  computed: {
    ACTION_ENUM() {
      return ACTION_ENUM;
    },
    pipelines() {
      return this.$store.getters.getPipelines;
    },
    pipelineIsCreating() {
      return this.$store.getters.getPipelineIsCreating;
    },
    featureModel() {
      return this.$store.getters.getFeatureModel;
    },
    applicationVersion() {
      return this.$store.getters.getApplicationVersion || 'cloudeweb';
    },
    hasPipelineConfiguration() {
      return this.$store.getters.getPipelineConfugurationExistence;
    }
  },
  watch: {
    // eslint-disable-next-line vue/no-arrow-functions-in-watch
    $route(route) {
      this.selectedBranch = route.query.branch;
      this.selectedTag = route.query.tag;
      this.getPipelines(route.query);
    }
  },
  // beforeDestroy() {
  //   window.removeEventListener('message', this.getFeatureModel);
  // },
  mounted() {
    this.selectedBranch = this.$route.query.branch;
    this.selectedTag = this.$route.query.tag;
    // document.addEventListener('fetch', console.log('FETCH'));
    // window.addEventListener('message', this.getFeatureModel);
    this.getFeatureModel();
    this.alias = this.$route.params.alias;

    if (!this.hasPipelineConfiguration) this.getPipelineConfugurationExistence();
    this.projectAlias = this.$route.params.projectAlias;
    CiCdService.getPipelines(
      this.$route.params.alias,
      this.$route.params.projectAlias,
      this.$route.query,
      this.$route.query.branch,
      this.$route.query.tag
    );
  },
  methods: {
    getPipelineConfugurationExistence() {
      CiCdService.getPipelineConfugurationExistence(
        this.$route.params.alias,
        this.$route.params.projectAlias
      );
    },
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    },
    getFeatureModel() {
      // (event)
      // console.log('Source of message: ' + event.source)
      // if (event.source instanceof ServiceWorker) {
      //   console.log('ServiceWorker message');
      //   if (event.data && event.data.type === 'setFeatureModel') {
      //     console.log('=====================STORE===========================');
      //     this.$store.dispatch('setFeatureModel', event.data.featureModel);
      //   }
      // }

      CiCdService.getFeatureModel(this.$route.params.alias, this.$route.params.projectAlias);
    },
    startPipeline() {
      const params = {};
      if (this.form && this.form.branch && this.form.branch.id) {
        params.branch = this.form.branch.id;
      }
      if (this.form && this.form.tag && this.form.tag.id) {
        params.tag = this.form.tag.id;
      }
      CiCdService.startPipeline(this.$route.params.alias, this.$route.params.projectAlias, params)
        .then(() => {
          smallNotification('success', { title: this.$t('ci_cd.pipeline.isRunning') });
        })
        .catch((err) => {
          smallNotification('danger', { title: 'Произошла ошибка' });
          throw err;
        });
    },
    clearPipelinesCache() {
      this.cacheIsClearing = true;
      this.closeClearCachePipelinesModalWindow();
      CiCdService.clearPipelinesCache(
        this.$route.params.alias,
        this.$route.params.projectAlias
      ).then(() => {
        this.cacheIsClearing = false;
        smallNotification('success', { title: this.$t('ci_cd.pipeline.runnerCacheCleared') });
      });
    },
    paginatePipeline(page) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page,
          branch: this.$route.query.branch,
          tag: this.$route.query.tag
        }
      });
    },
    openClearCachePipelinesModalWindow() {
      this.$refs.gfCustomModalWindowPipelinesClearCache.openModalWindow();
    },
    closeClearCachePipelinesModalWindow() {
      this.$refs.gfCustomModalWindowPipelinesClearCache.closeModalWindow();
    },
    openRestartPipelineModalWindow(e) {
      this.pipeline = e;
      this.$refs.gfCustomModalWindowPipelineRestart.openModalWindow();
    },
    closeRestartPipelineModalWindow() {
      this.$refs.gfCustomModalWindowPipelineRestart.closeModalWindow();
    },
    restartPipelineItem() {
      CiCdService.restartPipeline(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.pipeline.localId
      );
      this.$refs.gfCustomModalWindowPipelineRestart.closeModalWindow();
    },
    openCancelPipelineModalWindow(e) {
      this.pipeline = e;
      this.$refs.gfCustomModalWindowPipelineCancel.openModalWindow();
    },
    closeCancelPipelineModalWindow() {
      this.$refs.gfCustomModalWindowPipelineCancel.closeModalWindow();
    },
    cancelPipelineItem() {
      CiCdService.cancelPipeline(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.pipeline.localId
      );
      this.$refs.gfCustomModalWindowPipelineCancel.closeModalWindow();
    },
    openDeletePipelineModalWindow(e) {
      this.pipeline = e;
      this.$refs.gfCustomModalWindowPipelineDelete.openModalWindow();
    },
    closeDeletePipelineModalWindow() {
      this.$refs.gfCustomModalWindowPipelineDelete.closeModalWindow();
    },
    deletePipelineItem() {
      CiCdService.deletePipeline(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.pipeline.localId
      ).then(() => {
        this.closeDeletePipelineModalWindow();
        smallNotification('success', { title: this.$t('ci_cd.pipeline.deleted') });
      });
    },
    runPipelineWithSettings() {
      CiCdService.startPipeline(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.form
      )
        .then(() => {
          this.closePipelineSettingsModal();
          smallNotification('success', { title: this.$t('ci_cd.pipeline.isRunning') });
        })
        .catch(() => {
          this.closePipelineSettingsModal();
          smallNotification('danger', { title: 'Произошла ошибка' });
        });
    },
    closePipelineSettingsModal() {
      this.$refs.gfCustomModalWindowPipelineSettings.closeModalWindow();
    },
    getPipelines(query) {
      const branchName = query.branch;
      const tagName = query.tag;
      CiCdService.getPipelines(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        query,
        branchName,
        tagName
      );
    },
    onSelectorInput(type) {
      const query = { ...this.$route.query, page: 1 };
      if (type === 'branch') {
        query.branch = this.selectedBranch ? this.selectedBranch.title : undefined;
      } else if (type === 'tag') {
        query.tag = this.selectedTag ? this.selectedTag.name : undefined;
      }
      this.$router.push({ query }).catch(() => {});
      this.getPipelines(query);
    }
  },
  i18n: {
    messages: CiCdMessages
  }
};
</script>

<style lang="scss">
$this: '.сi-cd-pipelines';
$break_lg: 992px;
$break_xxl: 1400px;

#{$this} {
  &__actions {
    display: grid;
    align-items: center;
    grid-template-columns: 0.5fr 1fr;
    grid-template-rows: 1fr;
    @media screen and (max-width: #{$break_xxl}) {
      grid-template-columns: 1fr;
      gap: 15px;
    }

    &-filters {
      display: grid;

      gap: 15px;
      grid-template-columns: repeat(2, minmax(180px, 1fr));

      @media screen and (max-width: #{$break_xxl}) and (min-width: #{$break_lg}) {
        grid-template-columns: repeat(2, 1fr);
        gap: 50px;
      }

      @media screen and (max-width: #{$break_lg}) {
        grid-template-columns: 1fr;
      }
    }

    &-buttons {
      display: grid;
      align-items: center;
      gap: 15px;
      justify-self: end;
      grid-template-columns: repeat(3, auto);

      @media screen and (min-width: #{$break_lg}) {
        &:not(:has(.btn-cache)),
        &:not(:has(.btn-shedule)) {
          grid-template-columns: repeat(3, auto);
        }

        &:not(:has(.btn-shedule)):not(:has(.btn-cache)) {
          grid-template-columns: repeat(2, auto);
        }
      }

      @media screen and (max-width: #{$break_lg}) {
        grid-template-columns: 1fr auto;
        grid-template-rows: auto;
        width: 100%;

        & > * {
          grid-column: 1 / span 2;
        }

        .icon-setting {
          grid-column: 2;
        }

        &:not(:has(.btn-shedule)):has(.btn-cache) {
          .btn-cache {
            grid-column: 1;
          }
          .icon-setting {
            grid-row: 2;
          }
        }

        &:has(.btn-shedule):not(:has(.btn-cache)) {
          .btn-execute {
            grid-column: 1;
          }
          .icon-setting {
            grid-row: 2;
          }
        }

        &:not(:has(.btn-shedule)):not(:has(.btn-cache)) {
          .btn-execute {
            grid-column: 1;
          }
          .icon-setting {
            grid-row: 1;
          }
        }

        &:has(.btn-shedule):has(.btn-cache) {
          .icon-setting {
            grid-row: 3;
          }
        }
      }
    }
  }
}
</style>
